import { List, Record } from "immutable";

import createFromJS from "../../../createFromJS";
// import { FileConflictVersionRecord } from "./FileConflictVersionRecord";

// const fakeData = List([
//   FileConflictVersionRecord({
//     id: "aaa",
//     name: "Matt's iPad",
//     date: "12:30pm Today",
//     isCurrent: true
//   }),
//   FileConflictVersionRecord({
//     id: "bbb",
//     name: "Matt's Macbook Pro",
//     date: "11:00pm Yesterday",
//     isCurrent: false
//   })
// ]);

export const FileConflictStateRecord = Record({
  showConflictsModal: false,
  fileVersions: List()
});

const data = {
  collections: {
    fileVersions: "FileConflictVersionRecord"
  }
};

createFromJS.registerCallback(
  "FileConflictStateRecord",
  createFromJS.createNestedCallback(FileConflictStateRecord, data)
);
